<template>
  <div class="assistant">
    <div class="content">
      <el-row>
        <el-col :span="24"><img src="https://classoss.zhuokairui.cn/img/dingming/imgs/assistant/icon1.png" /></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>
<style scoped>
  img{width: 100%;height: auto;}
</style>



// WEBPACK FOOTER //
// src/pages/assistant.vue